(function () {
  var BLOCK = 'oddit-section-recommended-products';

  function initCarousel(section) {
    var track = section.querySelector('.' + BLOCK + '__grid');
    var cards = Array.prototype.slice.call(section.querySelectorAll('.' + BLOCK + '__card'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('.' + BLOCK + '__dot'));
    if (!track || cards.length === 0 || dots.length === 0) return;

    function setActive(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle(BLOCK + '__dot--active', i === index);
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    }

    // Card offsets are relative to the track's offsetParent, so normalise
    // against the first card to compare them with scrollLeft.
    function offsetOf(card) {
      return card.offsetLeft - cards[0].offsetLeft;
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        if (cards[i]) track.scrollTo({ left: offsetOf(cards[i]), behavior: 'smooth' });
      });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var x = track.scrollLeft;
        var nearest = 0;
        var best = Infinity;
        cards.forEach(function (card, i) {
          var distance = Math.abs(offsetOf(card) - x);
          if (distance < best) {
            best = distance;
            nearest = i;
          }
        });
        setActive(nearest);
      });
    }, { passive: true });
  }

  // The `recommendations` object is only populated when the section is fetched
  // via the Product Recommendations API, so the initial server render is empty.
  // Fetch the populated markup, swap it in, then wire up the carousel.
  function loadRecommendations(section) {
    var productId = section.getAttribute('data-product-id');
    if (!productId) {
      initCarousel(section);
      return;
    }

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var url = root + 'recommendations/products'
      + '?section_id=' + encodeURIComponent(section.id)
      + '&product_id=' + encodeURIComponent(productId)
      + '&limit=' + encodeURIComponent(section.getAttribute('data-recommendations-limit') || '4')
      + '&intent=' + encodeURIComponent(section.getAttribute('data-recommendations-intent') || 'related');

    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (text) {
        var fresh = new DOMParser().parseFromString(text, 'text/html').querySelector('.' + BLOCK);
        // Only swap when the API render actually has cards — the server render
        // may already be showing the fallback collection, which an empty
        // recommendations response must not blank out.
        var freshCards = fresh ? fresh.querySelectorAll('.' + BLOCK + '__card').length : 0;
        if (fresh && freshCards > 0) section.innerHTML = fresh.innerHTML;
        // Injected cards carry oddit-reveal (opacity 0) but missed the boot scan.
        if (window.OdditInteractions) window.OdditInteractions.refresh(section);
        initCarousel(section);
      })
      .catch(function () {
        initCarousel(section);
      });
  }

  function boot() {
    document.querySelectorAll('.' + BLOCK).forEach(loadRecommendations);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor: re-run when the section is added or reloaded.
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.' + BLOCK);
    if (section) loadRecommendations(section);
  });
})();
